export default function () {

  jQuery(document).on('ready', function() {
    jQuery('.nav__toggle').on('click', function() {
      jQuery('.nav__toggle, .nav__icon, .nav__overlay, body').toggleClass('open');
    });

    jQuery('.nav__item-overlay:not(.no-scroll), .nav__item-header:not(.no-scroll)').on('click', function(e) {

      if ( window.location.pathname == '/' ){
        e.preventDefault();
      }

      var target = jQuery(this).attr('href');

      if( jQuery(this).hasClass('nav__item-overlay') ) {
        jQuery('.nav__toggle, .nav__icon, .nav__overlay, body').removeClass('open');
      }

      if( jQuery(this).hasClass('nav__item-header') ) {
        jQuery('header').removeClass('nav-down').addClass('nav-up');
      }

      jQuery('html, body').animate({
        scrollTop: jQuery(target).offset().top,
      }, 2000);
    });
  });

  // Hide Header on on scroll down
  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = 80;
  var header = jQuery('header');
  var navIcon = jQuery('.nav__toggle');
  var navCart = jQuery('.nav__cart');
  var navMenu = jQuery('.nav__header');

  jQuery(window).scroll(function(){
    didScroll = true;
  });

  setInterval(function() {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

  function hasScrolled() {

    var st = jQuery(window).scrollTop();

    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
    return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight){
      // Scroll Down
      jQuery('header').removeClass('nav-down').addClass('nav-up');

    } else {
      // Scroll Up
      if(st + jQuery(window).height() < jQuery(document).height()) {
        jQuery('header').removeClass('nav-up').addClass('nav-down');
      }
    }
    if (st > navbarHeight) {
      header.delay( 200 ).queue(function(){
        navIcon.addClass('white');
        navCart.addClass('white');
        navMenu.addClass('white');
        header.addClass('white').dequeue();
      });
    } else {
      header.delay( 200 ).queue(function(){
        navIcon.removeClass('white');
        navMenu.removeClass('white');
        navCart.removeClass('white');
        header.removeClass('white').dequeue();
      });
    }

    lastScrollTop = st;
  }

}



// WEBPACK FOOTER //
// ./scripts/components/SetupNav.js